<template>
    <TeamDirectoryDetail v-if="$route.query.id" :key="$route.query.id" />
    <TeamDirectoryListing v-else />
</template>
<script>
import TeamDirectoryListing from './teamDirectoryListing.vue';
import TeamDirectoryDetail from './teamDirectoryDetail.vue';


export default {
    page: {
        title: "Team Directory",
    },
    components: { TeamDirectoryListing, TeamDirectoryDetail },
}
</script>
